<form #form="ngForm">
    <app-basic-information-update-card
        [timeOffPolicy]="timeOffPolicy"
        [timeOffTypes]="timeOffTypes"
        [timeOffApprovalFlows]="timeOffApprovalFlows"
        (onCreateTimeOffType)="showTimeOffTypeForm = $event"
        [isLoading]="timeOffCreateFlowService.isLoading$ | async"
    ></app-basic-information-update-card>
    <ng-container *ngIf="showTimeOffTypeForm">
        <app-time-off-type-card
            (onChange)="updateTimeOffPolicy()"
            [showHeaderInCard]="true"
            [timeOffType]="timeOffType"
        ></app-time-off-type-card>
        <app-payroll-integration-selection-card [timeOffType]="timeOffType" [isPaid]="timeOffType.isPaid">
        </app-payroll-integration-selection-card>
    </ng-container>
</form>
